import script from "./JtbdConstructor.vue?vue&type=script&setup=true&lang=js"
export * from "./JtbdConstructor.vue?vue&type=script&setup=true&lang=js"

import "./JtbdConstructor.vue?vue&type=style&index=0&id=0cb5afbd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cb5afbd"]])

export default __exports__